<nav class="navbar navbar-dark bg-dark mb-3">
  <a class="navbar-brand" href="/">Regional Mobile Apps</a>
  <ul class="navbar-nav">
    <a class="nav-link" routerLink="/unauthenticated">Logout</a>
  </ul>
</nav>
